import request from '@/utils/request'
import OSS from 'ali-oss'
import { Message } from 'element-ui'
import { getUuid } from '../utils/common'

const fileType = {
  'application/pdf': '.pdf',
  'image/jpeg': '.jpg',
  'image/png': '.png',
  'image/gif': '.gif',
  'audio/mp3': '.mp3',
  'video/mpeg4': '.mp4',
  'application/vnd.ms-powerpoint': '.ppt',
  'application/x-ppt': '.ppt',
  'text/plain': '.txt',
  'application/vnd.ms-excel': '.xls',
  'application/x-xls': '.xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xls',
  'text/xml': '.xml',
  'application/msword': '.doc',
  'video/avi': '.avi',
  'application/x-msdownload': '.exe',
  'text/html': '.html',
  'application/x-jpg': '.jpg',
  'application/x-javascript': '.js',
  'application/x-png': '.png',
  'application/json': 'json',
  'application/vnd.adobe.workflow': '.awf',
}

async function getStsParams(roleName) {
  const res = await request.get(`/api/examinee/v3/common/ossSts/${roleName}`)

  const ossSts = res

  const params = {
    accessKeyId: ossSts['assumeRoleResponse']['credentials']['accessKeyId'],
    accessKeySecret:
      ossSts['assumeRoleResponse']['credentials']['accessKeySecret'],
    stsToken: ossSts['assumeRoleResponse']['credentials']['securityToken'],
    bucket: ossSts['bucket'],
    endpoint: ossSts['endpoint'],
    resource: ossSts['resource'],
  }

  return params
}

export async function getRealUrl(path) {
  const roleName = path.split('/')[0]

  const params = await getStsParams(roleName)
  const client = new OSS(params)
  const result = client.signatureUrl(path)
  return result
}

export async function getRealUrls(arr) {
  const allPromise = arr.map(url => {
    return getRealUrl(url)
  })

  return Promise.all(allPromise)
}

// 分片上传
export function multipartUploadFile(
  file,
  dir = 'upload-file',
  type = '',
  onProgress,
  onSuccess,
) {
  return new Promise(async (resolve, reject) => {
    try {
      let typeArr = type.split(',')
      let some = typeArr.some(t => {
        return file.name.includes(t)
      })
      let ftype = fileType[file.type]
      if (type == '*') {
      } else if (ftype && type.split(',').indexOf(ftype) > -1) {
      } else if (some) {
      } else {
        Message('不支持该文件类型')
        reject(ftype)
        return false
      }
      let roleName = dir.split('/')[0]

      let param = await getStsParams(roleName)

      const parr = file.name.split('.')
      const nameWithoutExt = parr[parr.length - 2]
      let fixStr = file.name.substring(file.name.lastIndexOf('.'))

      let client = new OSS(param)

      let collegeid = dir.split('/')[1]
      let filePath =
        param.resource +
        '/' +
        collegeid +
        '/' +
        getUuid() +
        fixStr
      client
        .multipartUpload(filePath, file, {
          progress: async function(p, checkpoint) {
            onProgress && onProgress({ percent: p * 100 })
            if (p >= 1) {
              onSuccess && onSuccess()
            }
          },
        })
        .then(res => {
          if (
            res &&
            res.res &&
            res.res.requestUrls &&
            res.res.requestUrls.length > 0 &&
            res.res.requestUrls[0]
          ) {
            resolve({ name: file.name, ossPath: filePath })
          } else {
            reject(res)
          }
        })
        .catch(e => {
          reject(e)
        })
    } catch (error) {
      reject(error)
    }
  })
}
